export const getImageDimensions = async (imageData: File) =>
  new Promise<{ width: number; height: number }>((resolve) => {
    const img = new Image();
    var objectUrl = URL.createObjectURL(imageData);
    img.onload = function () {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: img.width, height: img.height });
    };
    img.src = objectUrl;
  });
